import { render, staticRenderFns } from "./surveyQuestionList.vue?vue&type=template&id=ecb6c608"
import script from "./surveyQuestionList.vue?vue&type=script&lang=js"
export * from "./surveyQuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports